import { render, staticRenderFns } from "./PromotionDappStepRewardForm.vue?vue&type=template&id=5b85d67e&scoped=true&"
import script from "./PromotionDappStepRewardForm.vue?vue&type=script&lang=js&"
export * from "./PromotionDappStepRewardForm.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDappStepRewardForm.vue?vue&type=style&index=0&id=5b85d67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b85d67e",
  null
  
)

export default component.exports